import { DeckResult } from '../types/deck'

export const DECK_IMAGES = {
  jeans:
    'https://cdn.magicpatterns.com/patterns/generated-images/c7918999-a358-49a1-bb89-35d937e55a02.jpg',
  shirt:
    'https://cdn.magicpatterns.com/patterns/generated-images/7e315601-6700-4ea1-86d5-b755c688f9f0.jpg',
  carSedan:
    'https://cdn.magicpatterns.com/patterns/generated-images/5da68f0b-769b-4b1a-a0b0-1994065eb01b.jpg',
  carHatch:
    'https://cdn.magicpatterns.com/patterns/generated-images/6ead030a-7a29-40b7-915a-861f4b6646ce.jpg',
  carSuv:
    'https://cdn.magicpatterns.com/patterns/generated-images/1ad5c193-1807-491d-9527-97d57553dd76.jpg',
  carSedanRear:
    'https://cdn.magicpatterns.com/patterns/generated-images/4d393955-4454-4780-8221-112f08eff38a.jpg',
  carSedanInterior:
    'https://cdn.magicpatterns.com/patterns/generated-images/87ea6657-2bc8-466e-9c7c-285c65d5261a.jpg',
  jacket:
    'https://cdn.magicpatterns.com/patterns/generated-images/20a4d482-5442-4360-af6b-5f26edb92387.jpg',
  sneakers:
    'https://cdn.magicpatterns.com/patterns/generated-images/900e02c7-dff6-49ed-b39a-3e931bdb75d6.jpg',
  tshirt:
    'https://cdn.magicpatterns.com/patterns/generated-images/b815910d-0dca-4965-a63d-1f9933eebe66.jpg',
  jeansIndigo:
    'https://cdn.magicpatterns.com/patterns/generated-images/3ba25a2a-0166-4383-94f6-3e39c0e35f94.jpg',
  jeansLight:
    'https://cdn.magicpatterns.com/patterns/generated-images/6414308a-0e5e-4111-94f4-172ede36dc55.jpg',
  jeansGrey:
    'https://cdn.magicpatterns.com/patterns/generated-images/fc398522-2e8b-481b-be1b-e05c7204edbe.jpg',
  jeansStone:
    'https://cdn.magicpatterns.com/patterns/generated-images/bbd5d615-1f41-4057-94f3-b02bbbf04433.jpg',
  shirtSky:
    'https://cdn.magicpatterns.com/patterns/generated-images/96947ad9-f78d-48a3-8462-cad7a673e2b1.jpg',
  shirtMint:
    'https://cdn.magicpatterns.com/patterns/generated-images/daacad31-ecfd-4d56-a1c8-80f6eeea81f4.jpg',
  shirtSand:
    'https://cdn.magicpatterns.com/patterns/generated-images/f9f5c1a0-f4d3-4698-a732-328c691e73ce.jpg',
  shirtCoral:
    'https://cdn.magicpatterns.com/patterns/generated-images/a5e52ada-185e-41bf-abd9-633d5eec611e.jpg',
}

/** Featured grid on the NOIR storefront (slide 6). */
export const APPAREL_FEATURED = [
  {
    badge: 'Best seller',
    category: 'Denim',
    title: 'Slim Fit Black Jeans',
    spec: 'Slim fit · Stretch denim · Black',
    price: 'AED 199',
    secondary: 'or 4 × AED 50',
    image: DECK_IMAGES.jeans,
  },
  {
    badge: 'New in',
    category: 'Shirts',
    title: 'Charcoal Oxford Shirt',
    spec: 'Slim fit · Cotton oxford · Charcoal',
    price: 'AED 179',
    secondary: 'or 4 × AED 45',
    image: DECK_IMAGES.shirt,
  },
  {
    badge: 'Staff pick',
    category: 'Outerwear',
    title: 'Black Bomber Jacket',
    spec: 'Regular fit · Water repellent',
    price: 'AED 349',
    secondary: 'or 4 × AED 87',
    image: DECK_IMAGES.jacket,
  },
  {
    badge: 'Best value',
    category: 'Shoes',
    title: 'Leather Low-Top Sneakers',
    spec: 'Full-grain leather · White',
    price: 'AED 289',
    secondary: 'or 4 × AED 72',
    image: DECK_IMAGES.sneakers,
  },
]

/** Lighter colourways the agent offers after the Arabic voice request. */
export const LIGHTER_SHIRT_RESULTS: DeckResult[] = [
  {
    id: 'shirt-sky',
    title: 'قميص أزرق سماوي',
    price: 'AED 179',
    meta: 'أزرق سماوي · مقاس ٣٤',
    availability: 'متوفر الآن',
    match: 'الأكثر مبيعاً',
    color: '#7DB8E8',
    image: DECK_IMAGES.shirtSky,
    primaryCta: 'أضف إلى السلة',
  },
  {
    id: 'shirt-mint',
    title: 'قميص أخضر نعناعي',
    price: 'AED 189',
    meta: 'نعناعي · مقاس ٣٤',
    availability: 'متوفر الآن',
    match: 'وصل حديثاً',
    color: '#A7D9C0',
    image: DECK_IMAGES.shirtMint,
    primaryCta: 'أضف إلى السلة',
  },
  {
    id: 'shirt-sand',
    title: 'قميص بيج رملي',
    price: 'AED 179',
    meta: 'رملي · مقاس ٣٤',
    availability: 'متوفر الآن',
    match: 'اختيار الفريق',
    color: '#D9C4A3',
    image: DECK_IMAGES.shirtSand,
    primaryCta: 'أضف إلى السلة',
  },
  {
    id: 'shirt-coral',
    title: 'قميص مرجاني',
    price: 'AED 199',
    meta: 'مرجاني · مقاس ٣٤',
    availability: 'متوفر الآن',
    match: 'لون جديد',
    color: '#F2836F',
    image: DECK_IMAGES.shirtCoral,
    primaryCta: 'أضف إلى السلة',
  },
]

export const APPAREL_SUGGESTIONS = [
  'Show me black jeans in size 34',
  'What fits a slim build?',
  'I need an outfit for a dinner',
  'Show me new arrivals',
]

export const APPAREL_BENEFITS = [
  { title: 'Free Returns', body: '30 days on unworn items' },
  { title: 'Free Delivery', body: 'On orders over AED 200' },
  { title: 'AI Size Guidance', body: 'Fit advice on every piece' },
  { title: 'Same-Day Dispatch', body: 'Order before 4 PM' },
]

/** Slide 5 — what Talab returns for the AED 100/day, 7-day request. */
export const CAR_RESULTS: DeckResult[] = [
  {
    id: 'car-1',
    title: 'Kia Pegas 2023',
    price: 'AED 89',
    priceNote: '/day',
    meta: 'Al Barsha, Dubai',
    match: '98% Match',
    availability: 'Available tomorrow',
    image: DECK_IMAGES.carSedan,
    gallery: [
      DECK_IMAGES.carSedan,
      DECK_IMAGES.carSedanRear,
      DECK_IMAGES.carSedanInterior,
    ],
    specs: [
      { label: 'Total 7 days', value: 'AED 623' },
      { label: 'Deposit', value: 'AED 500' },
    ],
    primaryCta: 'Book Now',
  },
  {
    id: 'car-2',
    title: 'Toyota Yaris 2022',
    price: 'AED 95',
    priceNote: '/day',
    meta: 'Business Bay, Dubai',
    match: '95% Match',
    availability: 'Available tomorrow',
    image: DECK_IMAGES.carHatch,
    specs: [
      { label: 'Total 7 days', value: 'AED 665' },
      { label: 'Deposit', value: 'AED 500' },
    ],
    primaryCta: 'Book Now',
  },
  {
    id: 'car-3',
    title: 'Kia Sonet 2023',
    price: 'AED 110',
    priceNote: '/day',
    meta: 'Al Quoz, Dubai',
    match: '91% Match',
    availability: 'Available tomorrow',
    image: DECK_IMAGES.carSuv,
    specs: [
      { label: 'Total 7 days', value: 'AED 770' },
      { label: 'Deposit', value: 'AED 700' },
    ],
    primaryCta: 'Book Now',
  },
]

/** Slide 6 — the fashion retail scenario. */
export const JEANS_RESULTS: DeckResult[] = [
  {
    id: 'jeans-1',
    title: 'Slim Fit Black Jeans',
    price: 'AED 199',
    meta: 'Size 34 · In stock',
    match: '99% Match',
    image: DECK_IMAGES.jeans,
    primaryCta: 'Add to Cart',
  },
  {
    id: 'jeans-2',
    title: 'Straight Black Denim',
    price: 'AED 229',
    meta: 'Size 34 · In stock',
    match: '96% Match',
    image: DECK_IMAGES.jeans,
    primaryCta: 'Add to Cart',
  },
]

/**
 * What the storefront answers with when the customer taps the Denim category:
 * the full colourway range, scrolled horizontally like the product's carousel.
 */
export const DENIM_RESULTS: DeckResult[] = [
  {
    id: 'denim-1',
    title: 'Slim Fit Black Jeans',
    price: 'AED 199',
    meta: 'Black · Slim',
    match: 'Best seller',
    color: '#111827',
    image: DECK_IMAGES.jeans,
    primaryCta: 'View',
  },
  {
    id: 'denim-2',
    title: 'Straight Indigo Jeans',
    price: 'AED 229',
    meta: 'Indigo · Straight',
    match: 'New in',
    color: '#1E3A8A',
    image: DECK_IMAGES.jeansIndigo,
    primaryCta: 'View',
  },
  {
    id: 'denim-3',
    title: 'Light Wash Slim Jeans',
    price: 'AED 219',
    meta: 'Light wash · Slim',
    match: 'Popular',
    color: '#93C5FD',
    image: DECK_IMAGES.jeansLight,
    primaryCta: 'View',
  },
  {
    id: 'denim-4',
    title: 'Charcoal Grey Jeans',
    price: 'AED 209',
    meta: 'Charcoal · Slim',
    match: 'Staff pick',
    color: '#4B5563',
    image: DECK_IMAGES.jeansGrey,
    primaryCta: 'View',
  },
  {
    id: 'denim-5',
    title: 'Stone Tapered Jeans',
    price: 'AED 239',
    meta: 'Stone · Tapered',
    match: 'New in',
    color: '#A8A29E',
    image: DECK_IMAGES.jeansStone,
    primaryCta: 'View',
  },
  {
    id: 'denim-6',
    title: 'Denim Trucker Jacket',
    price: 'AED 349',
    meta: 'Washed black · Regular',
    match: 'Outerwear',
    color: '#1F2937',
    image: DECK_IMAGES.jacket,
    primaryCta: 'View',
  },
  {
    id: 'denim-7',
    title: 'Relaxed Black Jeans',
    price: 'AED 189',
    meta: 'Black · Relaxed',
    match: 'Best value',
    color: '#111827',
    image: DECK_IMAGES.jeans,
    primaryCta: 'View',
  },
  {
    id: 'denim-8',
    title: 'Indigo Slim Jeans',
    price: 'AED 209',
    meta: 'Indigo · Slim',
    match: 'Popular',
    color: '#1E40AF',
    image: DECK_IMAGES.jeansIndigo,
    primaryCta: 'View',
  },
  {
    id: 'denim-9',
    title: 'Stone Straight Jeans',
    price: 'AED 219',
    meta: 'Stone · Straight',
    match: 'New in',
    color: '#A8A29E',
    image: DECK_IMAGES.jeansStone,
    primaryCta: 'View',
  },
  {
    id: 'denim-10',
    title: 'Light Wash Tapered Jeans',
    price: 'AED 229',
    meta: 'Light wash · Tapered',
    match: 'Staff pick',
    color: '#93C5FD',
    image: DECK_IMAGES.jeansLight,
    primaryCta: 'View',
  },
]

export const PAIRING_RESULTS: DeckResult[] = [
  {
    id: 'pair-1',
    title: 'Charcoal Oxford Shirt',
    price: 'AED 179',
    meta: 'Pairs with your jeans',
    match: 'Styled pick',
    image: DECK_IMAGES.shirt,
    primaryCta: 'Add to Cart',
  },
]

export const FRICTION_POINTS = [
  'Search manually',
  'Apply many filters',
  'Compare too many options',
  'Repeat selections',
  'Spend time before the right result',
]

export const BUSINESS_BENEFITS = [
  'Higher conversion potential',
  'Less friction in the buying journey',
  'AI-powered upselling and cross-selling',
  'Lead capture on every conversation',
  '24/7 product guidance',
  'Integrate via widget, link, or website',
]

export const CUSTOMER_BENEFITS = [
  'Faster discovery',
  'Natural conversational experience',
  'Fewer clicks',
  'More relevant results',
  'Easier path to purchase',
  'Personalized recommendations',
]

export const GTM_STEPS = [
  {
    phase: 'Phase 1',
    title: 'Your own AI storefront',
    body: 'Every business gets a Talab storefront trained on its own inventory.',
  },
  {
    phase: 'Phase 1',
    title: 'Deploy anywhere',
    body: 'Website widget, private link, or embedded inside an existing experience.',
  },
  {
    phase: 'Phase 2',
    title: 'Make inventory public',
    body: 'When ready, a business opts in to share its catalogue beyond its own storefront.',
  },
  {
    phase: 'Phase 2',
    title: 'The Talab Marketplace',
    body: 'Public inventory joins one network customers can ask across.',
  },
]
